module.exports = __webpack_public_path__ + "static/media/right-outer-join-icon.142925ad.svg";